import axios from './axios.service'
import authHeader from './auth-header'

const token = authHeader()

class SettingsService {
  async listAll () {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/settings`,
        { headers: token }
      )
      return response.data
    } catch (error) {
      return error
    }
  }

  async listAllMedias () {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/settingsmedia`,
        { headers: token }
      )
      return response.data
    } catch (error) {
      return error
    }
  }

  async setSettings (settings) {
    try {
      const response = await axios({
        method: 'post',
        url: `${process.env.VUE_APP_API_URL}/settings`,
        headers: { Authorization: token.Authorization },
        data: {
          settings
        }
      })
      return response
    } catch (error) {
      return error
    }
  }

  async setSettingsMedia (settings) {
    return new Promise((resolve, reject) => {
      try {
        const response = axios({
          method: 'post',
          url: `${process.env.VUE_APP_API_URL}/settingsmedia`,
          headers: { Authorization: token.Authorization },
          data: {
            settings
          }
        })
        resolve(response)
      } catch (error) {
        reject(error)
      }
    })
  }
}

export default new SettingsService()
